import {IPNSSearch} from '@portal-ng/PNSModels/PNSSearch.model';

export interface IPNSApplicationSearch extends IPNSSearch {
  locationId?: string;
}
